export default [
  {
    component: () => import('../pages/entities-page.vue'),
    name: 'admin.entities',
    path: '/:slug/admin/entities',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.all-group',
    path: '/:slug/admin/all-group',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.managed-funds',
    path: '/:slug/admin/managed-funds',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.managed-spvs',
    path: '/:slug/admin/managed-spvs',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.funds-in-progress',
    path: '/:slug/admin/funds-in-progress',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.spv-in-progress',
    path: '/:slug/admin/spv-in-progress',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.fund-formation-in-progress',
    path: '/:slug/admin/fund-formation-in-progress',
  },
  {
    component: () => import('../pages/new-entities-page.vue'),
    name: 'admin.spvs-on-hold',
    path: '/:slug/admin/spvs-on-hold',
  },
]
